__turbopack_context__.v({
  "connectButton": "ConnectButton-module-scss-module___BFiFa__connectButton",
  "connectIcon": "ConnectButton-module-scss-module___BFiFa__connectIcon",
  "connectWrapper": "ConnectButton-module-scss-module___BFiFa__connectWrapper",
  "desktopContent": "ConnectButton-module-scss-module___BFiFa__desktopContent",
  "guestConnectLink": "ConnectButton-module-scss-module___BFiFa__guestConnectLink",
  "mobileContent": "ConnectButton-module-scss-module___BFiFa__mobileContent",
});
